import { Pipe, PipeTransform } from '@angular/core';

import { QuestionField, QuestionType } from '@/tax-detail/models';
import { exportFraction } from '@/tax-detail/utils';

@Pipe({
    name: 'internalFieldEquals',
    standalone: false,
})
export class InternalFieldEqualsPipe implements PipeTransform {
    constructor() {}

    transform(field: QuestionField, value1: any, value2: any): boolean {
        if (field.type === QuestionType.File && Array.isArray(value1) && Array.isArray(value2)) {
            return value1.every((val: string) => value2.includes(val)) && value1.length === value2.length;
        }

        if (field.type === QuestionType.Fraction) {
            return exportFraction(value1 ?? '0') === exportFraction(value2 ?? '0');
        }

        return (value1 ?? '') === (value2 ?? '');
    }
}
